import React, { useContext } from "react"
import CloseModal from "../../../../components/CloseModal"

interface Props {
  setShowDetails: any
}

const PaymentCenterDetails: React.FC<Props> = ({ setShowDetails }) => {
  return (
    <div
      className="fixed w-screen h-screen top-0 left-0 zoee-backdrop-filter 
            z-[9001] flex items-center justify-center"
    >
      <div
        className="px-[40px] md:px-[100px] py-[80px] max-h-[90vh] w-[90%] md:w-[800px] max-w-[95%] bg-white 
                        main-shadow rounded-[16px] flex flex-col items-center relative overflow-y-auto"
      >
        <CloseModal
          callback={setShowDetails}
          styling={"absolute top-[24px] right-[24px]"}
        />
        <h1 className="text-[18px] md:text-[28px] font-semibold text-center mb-[36px]">
          Everything About Your Payments — in One Place
        </h1>
        <div className="w-full flex flex-col gap-[40px] text-center text-[18px]">
          <p className="">
            The Payment Center is your complete view of all payment activity on
            Zoee. You can review your saved cards, see upcoming and past
            transactions, and track every payment you’ve made across the
            platform.{" "}
          </p>
          <p>
            If you’re a coach, this is also where you can see your clients’
            payment activity — including which services they’ve enrolled in,
            who’s due for renewal, and upcoming charges. All transactions are
            securely processed through PayPal for safe, reliable payments.
          </p>
        </div>
      </div>
    </div>
  )
}

export default PaymentCenterDetails
